'use strict';

angular.module('ClinicApp').controller('ModalProviderAvailabilityCtrl', function($scope, $modalInstance, $q, provider, OCPhotoUtil, AvailabilityConstants, ProviderService, WizardHandler) {
  $scope.provider = provider;
  $scope.photo = OCPhotoUtil.primaryPhotoForModel('doctor', $scope.provider.doctor.primaryPhoto);

  $scope.userSelected = {
    units: 'days',
  };

  $scope.availabilityStates = AvailabilityConstants.availabilityStates;
  $scope.maxPicksPerState = 5;

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };

  $scope.saveTypicallyBooked = function(form) {
    if (form.$invalid) {
      return $q.reject();
    }
    WizardHandler.wizard().next();
    return $q.when();
  };

  $scope.done = function() {
    if ($scope.userSelected.units == 'weeks') {
      $scope.provider.availability.daysInAdvanceFullyBooked *= 7;
    }
    return ProviderService.updateProvider($scope.provider.id, {
      availability: $scope.provider.availability,
    }).then(function() {
      $modalInstance.close();
    });
  };

});
